declare const __OFFLINE_BUILD_ID__: string;

// Explicitly copied by the member. No account, credentials, location or stored data.
export function appDetails() {
  const probe=document.createElement('div');
  probe.style.cssText='position:fixed;visibility:hidden;pointer-events:none;width:0;height:100vh;padding-top:env(safe-area-inset-top);padding-bottom:env(safe-area-inset-bottom);box-sizing:border-box;';
  document.body.appendChild(probe);
  try {
    const style=getComputedStyle(probe);
    const safeArea={top:style.paddingTop,bottom:style.paddingBottom};
    const vh=probe.getBoundingClientRect().height;
    probe.style.height='100dvh';
    const dvh=probe.getBoundingClientRect().height;
    const shell=document.querySelector('.app-shell')?.getBoundingClientRect();
    const viewport=window.visualViewport;
    return JSON.stringify({
      build:__OFFLINE_BUILD_ID__,
      browser:navigator.userAgent,
      installed:window.matchMedia('(display-mode:standalone)').matches||(navigator as Navigator & {standalone?:boolean}).standalone===true,
      screen:{width:screen.width,height:screen.height},
      window:{width:innerWidth,height:innerHeight},
      visualViewport:viewport?{width:viewport.width,height:viewport.height,offsetTop:viewport.offsetTop,scale:viewport.scale}:null,
      css:{vh,dvh,safeArea},
      shell:shell?{top:shell.top,bottom:shell.bottom,height:shell.height}:null,
    },null,2);
  } finally {probe.remove();}
}
